import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SellProduct from './SellProduct';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, forSale, error, message,
  } = state.market;
  return {
    isLoading,
    forSale,
    error,
    message,
  };
}

const Styled = withStyles(styles)(SellProduct);

export default connect(
  mapStateToProps,
)(Styled);
